export default __webpack_public_path__ + "static/media/mayowa_cloth.3d6c8a14.png";